module.exports = __webpack_public_path__ + "static/media/img-quiz-7.e5666ea1.jpg";